import { h } from 'preact'
import { useEffect } from 'preact/hooks'
import Modal from '../lib/modal'

export default function ProductModal({ product, children, id, onClose }) {
  useEffect(() => {
    Modal.show(this.props.id, { onClose })
  }, [])

  return (
    <div class="micromodal micromodal-slide" id={id} aria-hidden="true">
      <div class="micromodal--overlay" tabindex="-1" data-modal-close>
        <div class="micromodal--container" role="dialog" aria-modal="true" aria-labelledby="modal-2-title">
          <header class="micromodal--header">
            <h2 class="micromodal--title" id="modal-1-title">
              {product.title} | {product.price}
            </h2>
            <button type="button" class="micromodal--close" aria-label="Close modal" data-modal-close />
          </header>
          <main class="micromodal--content upsell-modal-item" id="modal-2-content">
            <a href={product.url} class="upsell-image">
              <img src={product.image} alt={product.title} />
            </a>

            <div class="micromodal--main">
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}
